<div class="shipment-home">
  <app-table
    [columns]="shipmentColumns"
    [data]="shipmentState.data()"
    [config]="shipmentConfig"
    [pagination]="shipmentPagination"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (actionClick)="onActionClick($event)"
    (searchChange)="onSearchChange($event)"
    (filterChange)="onFilterChange($event)"
    (dateRangeChange)="onDateRangeChange($event)"></app-table>
</div>
